<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <PrivacyZTK v-if="routing === 'ZTK'" from="privacy" />
      <PrivacyBetterDoc v-else-if="routing === 'BetterDoc'" :link="link" />
      <PrivacyArag v-else-if="routing === 'ARAG Case Management'" />
      <PrivacyAragZahn
        v-else-if="routing === 'ARAG Case Management Zahn'"
        :shouldOpenFormContact="shouldOpenFormContact"
      />
      <PrivacyMedgate v-else />
    </ion-content>
  </ion-page>
</template>

<script>
import PrivacyMedgate from "@/components/Privacy";
import PrivacyZTK from "@/components/PrivacyZTK";
import PrivacyBetterDoc from "@/components/PrivacyBetterDoc";
import PrivacyArag from "@/components/PrivacyArag";
import PrivacyAragZahn from "@/components/PrivacyAragZahn";
import { arrowBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonBackButton,
} from "@ionic/vue";

export default {
  components: {
    PrivacyMedgate,
    PrivacyZTK,
    PrivacyBetterDoc,
    PrivacyArag,
    PrivacyAragZahn,
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonBackButton,
  },
  props: {
    routing: {
      required: true,
      type: String,
    },
    link: {
      required: false,
      type: String,
      default: "",
    },
    shouldOpenFormContact: {
      required: false,
      type: String,
      default: "false",
    },
  },
  setup() {
    return { arrowBack };
  },
};
</script>

<style></style>
